// trackingRetry — the shared React Query retry policy for the tracking and
// finance hooks. Kept in its own leaf module (rather than inside useTracking)
// so that test files which `vi.mock("./useTracking")` with an explicit factory
// don't have to re-declare it: any hook module can import the real policy here
// without being caught by a sibling module's mock.
//
// Policy: don't retry on 4xx (client errors are deterministic); retry up to
// three times on 5xx or network failures (status = 0).

import { ApiError } from "../services/api";

export function trackingRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
    return false;
  }
  return failureCount < 3;
}
